import React from "react";
import {Card, Col} from "react-bootstrap";
import Table from "./Table";
import { useTranslation } from "react-i18next";

const CardTable = (props) => {

    const {t} = useTranslation();
    return (
        <>
            <Col md={props.width} className={props.className}>
                <Card className={props.shadow === false ? "" : "shadow"}>
                    {
                        props.withoutHeader ? "" : <Card.Header className="py-3">
                            <p className="m-0 font-weight-bold">{props.title || props.tittle}</p>
                        </Card.Header>
                    }

                    <Card.Body>
                        {
                            props.columns ?
                                <Table
                                    setLoader={props.setLoader}
                                    source={props.source}
                                    columns={typeof props.columns === 'function' ? props.columns(t) : props.columns}
                                    reload={props.reload}
                                    additionalFilter={props.additionalFilter}
                                    checked={props.checked}
                                    showAlways={props.showAlways}
                                    readOnly={props.readOnly}
                                    disableRule={props.disableRule}
                                    onReload={props.onReload}
                                    setChecked={props.setChecked}
                                    initData={props.initData}
                                    striped={props.striped}
                                    tableHeader={props.tableHeader}
                                    pagination={props.pagination}
                                    searchConf={props.searchConf}
                                    externalState={props.externalState}
                                    conditionalRowStyles={props.conditionalRowStyles}
                                    externalState2={props.externalState2}
                                    setExternalState={props.setExternalState}
                                /> : ""
                        }

                        {props.children}
                    </Card.Body>
                </Card>
            </Col>
        </>
    );
};

export default CardTable;